// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TemplateTermsAndConditions_wrapper__i_TFg","heading":"TemplateTermsAndConditions_heading__DI_Nr"};